




























































































































































import { Guid } from 'guid-typescript'
import { Component, Prop, PropSync, VModel, Watch } from 'vue-property-decorator'
import draggable from 'vuedraggable'

import DrawerWidthMixin from '../../../../logic/helpers/DrawerWidthMixin'
import { VueComponent } from "../../../../shared/types/VueComponent";
import Tags from '../../../Tags/Tags.vue'
import ButtonsManager from '../ButtonsConstructor/ButtonsManager'
import Button, { ButtonStruct } from '../ButtonsConstructor/buttons'
import { ButtonsRows } from '../ButtonsConstructor/types'
import ButtonsBuildManager from './components/ButtonsBuildManager.vue'

@Component({
  components: {
    ButtonsBuildManager,
    draggable,
    Tags,
  }
})
export default class KeyboardBuilder extends DrawerWidthMixin {
  @VModel() buttonsRows!: ButtonsRows

  @PropSync('editKeyboardIsOpen') isOpen!: boolean

  @Prop() buttonsManager!: ButtonsManager

  @Prop() buttonsHelpView!: VueComponent | string

  @Watch('isOpen')
  isOpenWatcher(val: boolean): void {
    if (!val) {
      this.hideButtons = false
      this.currentButton = null
      this.selected = null
    }
  }

  hideButtons = false

  addedOnNewRow = []

  dragging = false

  currentButton: null | Button = null

  selected: null | { button: ButtonStruct, row: string } = null

  touchTime: null | Date = null
  touchLog(): void {
    this.touchTime = new Date
  }

  touchEnd(struct: ButtonStruct, guid: string): void {
    if (Number(new Date) - Number(this.touchTime) < 80) {
      this.selectButton(struct, guid)
      this.dragging = false
    }
  }

  selectButton(struct: ButtonStruct, rowGuid: string): void {
    if (!this.selected || this.selected.button !== struct) {
      this.selected = {
        button: struct,
        row: rowGuid
      }
    } else {
      this.selected = null
    }
  }

  checkRow(index: number): void {
    if (!this.buttonsRows[index].data.length) {
      this.buttonsRows.splice(index, 1)
    }
  }

  addButtonInNewRow(struct: ButtonStruct): void {
    this.buttonsRows.push({
      guid: Guid.create().toString(),
      data: [ struct ]
    })
    this.addedOnNewRow = []
  }

  editButton(struct: ButtonStruct): void {
    if (this.selected) {
      const row = this.buttonsRows.find((r) => r.guid === this.selected?.row)

      if (row) {
        const index = row.data.findIndex((b) => b.guid === struct.guid)

        if (index !== -1) {
          row.data.splice(index, 1, struct)
        }
      }
    }

    this.selected = null
  }

  removeButton(struct: ButtonStruct): void {
    if (this.selected) {
      const row = this.buttonsRows.find((r) => r.guid === this.selected?.row)

      if (row) {
        const index = row.data.findIndex((b) => b.guid === struct.guid)

        if (index !== -1) {
          row.data.splice(index, 1)

          this.checkRow(this.buttonsRows.indexOf(row))
        }
      }
    }

    this.selected = null
  }

  created(): void {
    this.currentButton = this.buttonsManager.firstButton
  }
}
